import React, {Component} from 'react';
import {DialogPR} from './DialogPR';
import PropTypes from 'prop-types';
import './Dialog.css';

function resolveAppendTo(appendTo) {
    if (typeof document === 'undefined') {
        return null;
    }
    if (!appendTo || appendTo === 'body') {
        return document.body;
    }
    if (typeof appendTo === 'string') {
        return document.querySelector(appendTo) || document.body;
    }
    return appendTo;
}

export default class Dialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible,
            header: this.props.header
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({ visible: nextProps.visible, header: nextProps.header });
    }

    render() {
        return (
            <DialogPR
                modal={true}
                resizable={true}
                maximizable={true}
                responsive={true}
                {...this.props}
                appendTo={resolveAppendTo(this.props.appendTo)}
                visible={this.state.visible}
                header={this.state.header}
                ref={(el) => this.refDialog = el}
            />
        );
    }

    maximaze = (maximazed) => {
        this.refDialog.setState({ maximized: maximazed });
    }
}

Dialog.propTypes = {
    visible: PropTypes.bool,
    header: PropTypes.string,
    onHide: PropTypes.func
};
